<template>
    <div class="shopShareMain" @click.self="removeDialog">
        <div ref="content" style="width: 80%; position: relative;z-index: 999;">
            <div style="width: 100%; height: 40px;text-align: center;position: relative;c">
                <img
                    src="static/images/product/icon_close.png"
                    @click="removeDialog"
                    style="position: absolute;left: calc(50% - 20px);top: 0;width: 40px; height: 40px;"
                />
            </div>

            <img
                ref="post"
                style="
                    position: absolute;
                    width: 100%;
                    top: 50px;
                    left: 0;
                "
            />

            <div
                style="
                    position: absolute;
                "
                v-show="false"
            >
                <div ref="qrCodeImg" />  
            </div>
        </div>
    </div>
</template>

<script>

const canvasWidth = 1181;
const canvasHeight = 1772;

//
export default {
    name: 'ShopShare',

    props: {
        shopName: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            qrCodeText: "",
        }
    },

    created()
    {
        //
        this.qrCodeText = window.location.href;
    },

    mounted() {
        //
        this.$nextTick(() => {
            this.$refs.content.style.height = `${parseInt(this.$refs.content.getClientRects()[0].width * canvasHeight / canvasWidth)}px`;
        })

        //
        new QRCode(this.$refs.qrCodeImg, {
            text: this.qrCodeText,
            width: 750,
            height: 750,
            colorDark : "#000000",
            colorLight : "#ffffff",
            correctLevel : QRCode.CorrectLevel.H
        });

        //
        this.getCvs();
    },

    methods: {
        removeDialog() {
            this.remove()
        },

        /**
         * 
         */
        async handleImage(ctx, src, x, y, width, height)
        {
            let img = new Image()

            //
            img.src = src;
            img.crossOrigin = 'anonymous';

            await new Promise((resolve, reject) => {
                //
                img.onload = () => {
                    ctx.drawImage(
                        img, 
                        x, 
                        y, 
                        width, 
                        height
                    );

                    //
                    resolve();
                }

                //
                setTimeout(() => {
                    reject('img load failed')
                }, 2000);
            })
            
        },

        /**
         * 
         */
        async handleImageHash(ctx, src, x, y, width, height)
        {
            let img = new Image()

            //
            img.src = src;
            img.crossOrigin = 'anonymous';

            //
            await new Promise((resolve, reject) => {
                //
                img.onload = () => {
                     //
                    ctx.drawImage(
                        img, 
                        x, 
                        y, 
                        width, 
                        height
                    );

                    //
                    resolve();
                }

                //
                setTimeout(() => {
                    reject('img load failed')
                }, 4000);
            })
        },

        /**
         * 合成文字
         */
        computeCharacterWidth(char, wordWidth)
        {
            let width;
            if(/[.,]/.test(char))
            {
                width = wordWidth / 3;
            }
            else if(/[\u4E00-\u9FFF\u3002\uff1b\uff0c\uff1a\u201c\u201d\uff08\uff09\u3001\uff1f\u300a\u300b\uff01\u3010\u3011\uffe5]/.test(char))
            {
                width = wordWidth;
            }
            else
            {
                width = 3 / 5 * wordWidth;
            }
            
            //
            return width;
        },

        computeStringOccupyLineNum(wordString, wordWidth, maxWidth = canvasWidth)
        {
            let y = 0

            //
            let currentTotalWidth = 0;

            //
            for (let i = 0; i < wordString.length; i++) { 
                // 判断字符类型
                let charWidth = this.computeCharacterWidth(wordString[i], wordWidth);

                // 判断是否需要换行
                if(currentTotalWidth + charWidth > maxWidth)
                {
                    //
                    currentTotalWidth = 0;

                    // 计算目前是第几行
                    y += 1;
                }

                //
                currentTotalWidth += charWidth;
            }

            // 返回总共是几行
            return y + 1;
        },

        handleWord(ctx, wordString, wordX, wordY, wordWidth, wordHeight, maxWidth = canvasWidth, ifTextAlignCenter = false) {
            let y = 0

            //
            let currentTotalWidth = 0;

            //
            for (let i = 0; i < wordString.length; i++) { 
                // 判断字符类型
                let charWidth = this.computeCharacterWidth(wordString[i], wordWidth);

                // 判断是否需要换行
                if(currentTotalWidth + charWidth > maxWidth)
                {
                    //
                    currentTotalWidth = 0;

                    // 计算目前是第几行
                    y += 1;
                }

                // 判断是否是最后一行
                if(currentTotalWidth == 0 && ifTextAlignCenter)
                {
                    //
                    let totalWidth = 0;
                    for(let j = i; j < wordString.length; j ++)
                    {
                        // 判断字符类型
                        let charWidth = this.computeCharacterWidth(wordString[i], wordWidth);

                        //
                        totalWidth += charWidth;
                    }

                    if(totalWidth < maxWidth)
                    {
                        currentTotalWidth = (maxWidth - totalWidth) / 2;
                    }
                }

                //
                ctx.fillText(wordString[i], wordX + currentTotalWidth, wordY + y * wordHeight)

                //
                currentTotalWidth += charWidth;
            }

            // 返回总共是几行
            return y + 1;
        },

        clipWords(wordString, wordWidth, maxWidth = canvasWidth, maxLine)
        {
            let y = 0

            //
            let currentTotalWidth = 0;

            //
            for (let i = 0; i < wordString.length; i++) { 
                // 判断字符类型
                let charWidth = this.computeCharacterWidth(wordString[i], wordWidth);

                // 判断是否需要换行
                if(currentTotalWidth > maxWidth)
                {
                    //
                    currentTotalWidth = 0;

                    // 
                    if(y + 1 == maxLine)
                    {
                        return {
                            wordString: wordString.substring(0, i - 1 - 3) + "...",
                            lines: maxLine,
                        }
                    }

                    // 进入下一行
                    y += 1;
                }

                //
                currentTotalWidth += charWidth;
            }

            //
            return {
                wordString,
                lines: y + 1,
            }
        },

        /**
         * 
         */
        getCvs() {  
            //
            let canvas = document.createElement("canvas");
            let ctx = canvas.getContext('2d')
            canvas.width = canvasWidth
            canvas.height = canvasHeight
            
            //
            let img = new Image()
            img.crossOrigin = 'anonymous';
            if(process.env.ziubao_shop_platform == 'ziubao')
            {
                img.src = 'static/images/shop/show-bg.jpg'
            }
            else if(process.env.ziubao_shop_platform == 'ziubao_test')
            {
                img.src = 'static/images/shop/show-bg.jpg'
            }
            img.onload = () => {
                (async () => {
                    // 底图
                    ctx.drawImage(img, 0, 0, canvas.width, canvas.height)

                    // 店铺名称
                    let shopNameFontWidth = 76;
                    let shopNameFontHeight = 76;
                    let shopNameMaxWidth = 1032 - 48;
                    let shopNameY;
                    let shopNameClipResult = this.clipWords(this.shopName, shopNameFontWidth, shopNameMaxWidth, 2);
                    if(shopNameClipResult.lines >  1)
                    {
                        //
                        shopNameY = 548 - 64
                    }
                    else
                    {
                        shopNameY = 548 - 36
                    }
                    ctx.font = '56px Arial'
                    this.handleWord(
                        ctx,
                        shopNameClipResult.wordString,
                        75 + 32,
                        shopNameY,
                        shopNameFontWidth,
                        shopNameFontHeight,
                        shopNameMaxWidth,
                        true,
                    )

                    // 店铺二维码
                    try {
                        //
                        let qrImg = this.$refs.qrCodeImg.getElementsByTagName('img')[0];

                        //
                        let src = qrImg.src

                        //
                        if(window.gtzn.platform == 'android')
                        {
                            //
                            src = this.$refs.qrCodeImg.getElementsByTagName('canvas')[0].toDataURL();
                        }
                        
                        //
                        await this.handleImageHash(
                            ctx,
                            src, 
                            75 + 156, 
                            548 + 176, 
                            700, 
                            700 
                        );
                    } catch (error) {
                        this.Toast(`二维码显示失败, ${error.toString()}`)
                    }

                    /**
                     * 
                     */
                    this.$refs.post.src = canvas.toDataURL("image/png");
                })();
            }
        },
    },
}
</script>

<style lang="scss" scoped>
//
.shopShareMain {
    z-index: 1990;
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    display: flex;
    background-color: rgba(0, 0, 0, 0.7);
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

</style>